import { datadogRum } from "@datadog/browser-rum"
import { MP_ENV } from "./config"

export function initDatadog() {
	if (MP_ENV === "PROD") {
		datadogRum.init({
			applicationId: process.env.REACT_APP_DATADOG_APP_ID as string,
			clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN as string,
			site: "datadoghq.com",
			service: "member-portal-js",
			env: "prod",
			version: "0.1.1",
			sessionSampleRate: 50,
			sessionReplaySampleRate: 20,
			trackUserInteractions: true,
			trackResources: true,
			trackLongTasks: true,
			defaultPrivacyLevel: "mask-user-input",
		})
		console.log("Datadog initialized")
	}
}
